import Report from "./icon/Report";
import Dashboard from "./icon/Dashboard";
import Home from "./icon/Home";
import Search from "./icon/Search";

export const menu = [
  {
    judul: "Dashboard",
    link: "/dashboard",
    icon: (
      <Dashboard/>
    ),
  },
  {
    judul: "Register Nasabah",
    link: "/register",
    icon: (
     <Home/>
    ),
  },
  {
    judul: "Cari",
    link: "/search",
    icon: (
      <Search/>
    ),
  },
  {
    judul: "Laporan",
    link: "/report",
    icon: <Report />,
  },
];
